import { collection, doc, getDocs, writeBatch } from 'firebase/firestore';
import { db } from '../../firebase/firebase';
import { isDemoMode } from '../../utilities/demoMode';
import { deriveHasWordLevelTranscriptFromTimingData } from '../../utils/recordingTranscription';

const RECORDINGS_COLLECTION = 'Recordings';
const BACKFILL_STORAGE_KEY = 'overhear_hasWordLevelTranscript_backfill_v1';
const BATCH_SIZE = 400;

/**
 * One-off backfill: set hasWordLevelTranscript on Recordings docs that lack the field.
 * Skips in demo mode and after successful completion (localStorage marker).
 */
export async function ensureHasWordLevelTranscriptBackfill(): Promise<void> {
  if (isDemoMode()) {
    return;
  }

  if (typeof localStorage !== 'undefined' && localStorage.getItem(BACKFILL_STORAGE_KEY) === 'done') {
    return;
  }

  const recordingsRef = collection(db, RECORDINGS_COLLECTION);
  const snapshot = await getDocs(recordingsRef);

  const toUpdate: Array<{ id: string; hasWordLevelTranscript: boolean }> = [];

  for (const docSnapshot of snapshot.docs) {
    const data = docSnapshot.data();
    if (typeof data.hasWordLevelTranscript === 'boolean') {
      continue;
    }

    toUpdate.push({
      id: docSnapshot.id,
      hasWordLevelTranscript: deriveHasWordLevelTranscriptFromTimingData(data.timingData),
    });
  }

  for (let i = 0; i < toUpdate.length; i += BATCH_SIZE) {
    const chunk = toUpdate.slice(i, i + BATCH_SIZE);
    const batch = writeBatch(db);

    chunk.forEach(({ id, hasWordLevelTranscript }) => {
      batch.update(doc(db, RECORDINGS_COLLECTION, id), { hasWordLevelTranscript });
    });

    await batch.commit();
  }

  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(BACKFILL_STORAGE_KEY, 'done');
  }
}
